import React, { useEffect } from 'react';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
interface MetaPixelWindow extends Window {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
}
const PIXEL_ID = '1021180653952573';
const SCRIPT_ID = 'meta-pixel-script';
export function MetaPixel() {
  useEffect(() => {
    const pixelWindow = window as MetaPixelWindow;
    let fbq = pixelWindow.fbq;
    if (!fbq) {
      fbq = ((...args: unknown[]) => {
        if (fbq?.callMethod) {
          fbq.callMethod(...args);
        } else {
          fbq?.queue.push(args);
        }
      }) as PixelFunction;
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      pixelWindow.fbq = fbq;
      pixelWindow._fbq = fbq;
    }
    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    fbq('init', PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return null;
}